import BaseTableReport from 'components/atoms/base-table/report/report';
import { useTranslation } from 'react-i18next';
import { ELASTIC_SEARCH_MAX_ITEMS } from 'constants/count';
import { safeClamp } from 'utils/helpers/safeClamp';

import s from './styles.module.scss';
import { useColumns } from './columns/useColumns';

import type { FC } from 'react';
import type {
  InteractiveTimeItem,
  Filters,
  AppendFilters,
  SortField,
} from 'infrastructure/hooks/interactiveTimeDashboard/types';
import type { SortParam, SortState } from 'infrastructure/types';

interface Props {
  isLoading: boolean;
  interactiveTime?: {
    data?: InteractiveTimeItem[] | undefined;
    count?: number | undefined;
  };
  filters: Filters;
  changePage: (page: number) => void;
  appendFilters: AppendFilters;
}

const InteractiveTimeDashboardTable: FC<Props> = ({
  interactiveTime,
  isLoading,
  filters,
  changePage,
  appendFilters,
}) => {
  const { t } = useTranslation();
  const columns = useColumns();

  const onSort = (sort?: SortParam) => {
    const col = sort?.[0] as SortField | undefined;
    const dir = sort?.[1]?.toLowerCase() as SortState | undefined;
    if (col && dir) {
      const sortString = `${col}:${dir}` as const;
      appendFilters({ sortString });
    } else {
      appendFilters({ sortString: null });
    }
  };

  return (
    <div className={s.wrapper}>
      <BaseTableReport
        isLoading={isLoading}
        columns={columns}
        dataCy="interactiveTimeDashboard-table"
        headerTitle={t('labels.patients')}
        dataSource={interactiveTime?.data}
        totalCount={interactiveTime?.count}
        pagination={{
          current: filters.page,
          pageSize: filters.items,
          total: safeClamp(interactiveTime?.count, 0, ELASTIC_SEARCH_MAX_ITEMS),
          onChange: changePage,
        }}
        onSort={onSort}
        showCount
        anchor
      />
    </div>
  );
};

export default InteractiveTimeDashboardTable;
